const navigationPaths = {
    register: {
        base: "/register",
        language: "/register/language",
        invitation: "/register/invitation",
        company: "/register/company",
        legalData: "/register/legal",
        bankAccount: "/register/account",
        masterUser: "/register/master-user",
        representativeUser: "/register/representative-user",
        representatives: "/register/representatives",
        beneficialOwners: "/register/beneficial-owners",
        password: "/register/password",
        overview: "/register/overview",
        completion: "/register/completion",

        userActivation: "/activation"
    },
    login: {
        base: "/login",
        resetPassword: "/reset-password",
        help: "/user/sendEmail",
    },
    dashboard: "/dashboard",
    seller: {
        debtors: "/seller/debtor-management",
        marketSounding: "/seller/market-sounding",
        sell: "/seller/sell",
        allReceivables: "/seller/all-receivables",
        payments: "/seller/payments",
        putOptions: "/seller/put-option",
        trackPay: "/seller/trackPay"
    },
    investor: {
        exchange: "/investor/exchange",
        payments: "/investor/payments",
        investments: "/investor/investments",
        riskAssessment: "/investor/risk",
    },
    debtor: {
        ipu: "/debtor/ipu",
        trackPay: "/debtor/trackPay"
    },
    admin: {
        profile: "/user/profile",
        users: "/user/users",
        accounts: "/user/accounts",
        company: "/user/company",
        invoices: "/user/invoices",
        walbingReferrer: "/user/referrer",
        contracts: "/user/contracts",
    },
    download: {
        receivableDocuments: "/receivable-document-download"
    },
    accessDenied: "/access-denied",
    redirect: "/redirect",
    companyDisclosure: "/company-disclosure"
};

export {
    navigationPaths
}
